import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SendOtpNewTelCtrl = function (fn, er, telephone, token, ids) {

    var config = {
        headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'MT_SESSION_ID': ids
        },
    };

    var data = {
        cellNumber: telephone,
    };

    axios
        .post(ApiConfig.url.SEND_OTP_AND_NEW_TEL, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
}

export { SendOtpNewTelCtrl };